import { useFormik } from "formik";
import TextInput from "../../../../components/inputs/textInput";
import { useTranslation } from "react-i18next";
import UserIcon from "../../../../icons/userIcon";
import BoxIcon from "../../../../icons/boxIcon";
import PhoneIcon from "../../../../icons/phoneIcon";
import ShoppingBasketIcon from "../../../../icons/shoppingBasketIcon";
import PackageIcon from "../../../../icons/packageIcon";
import LocationIcon from "../../../../icons/locationIcon";
import { useState } from "react";
import MessagePopup from "../../../../components/popups/messagePopup";
import QrCodeIcon from "../../../../icons/qrCodeIcon";
import { getContrastingTextColor, primaryColor } from "../../../../utils";
import BoardButton from "../../../../components/buttons/boardButton";

const IssueBillLading = () => {
  const [requestSent, setRequestSent] = useState(false);
  const formik = useFormik({
    initialValues: {
      shipmentType: "fast",
      shipmentType2: "land",
    },
    onSubmit: (values) => {
      setRequestSent(true);
    },
  });

  const { t } = useTranslation();
  return (
    <main className="relative text-black dark:text-white">
      <h2 className="my-4 text-xl capitalize">{t("customerDetails")}</h2>
      <form onSubmit={formik.handleSubmit}>
        <section className="inputs">
          <TextInput
            icon={<UserIcon />}
            formik={formik}
            label={t("name")}
            name={"name"}
            placeholder={t("enterCustomerName")}
          />
          <TextInput
            icon={<PhoneIcon fill={"#888888"} className="size-6" />}
            formik={formik}
            label={t("phone")}
            name={"phone"}
            placeholder={t("enterPhoneNumber")}
          />
        </section>

        <h2 className="my-4 text-xl capitalize">{t("goodsDetails")}</h2>
        <section className="inputs">
          <TextInput
            icon={<BoxIcon fill={"#888888"} className="size-6" />}
            formik={formik}
            label={t("type")}
            name={"type"}
            placeholder={t("type")}
          />
          <TextInput
            icon={<ShoppingBasketIcon />}
            formik={formik}
            label={t("weight")}
            name={"weight"}
            placeholder={t("weight")}
          />
          <TextInput
            icon={<PackageIcon />}
            formik={formik}
            label={t("quantity")}
            name={"quantity"}
            placeholder={t("quantity")}
          />
        </section>

        <h2 className="my-4 text-xl capitalize">{t("addresses")}</h2>
        <section className="inputs">
          <TextInput
            icon={<LocationIcon className="size-6" fill={"#888888"} />}
            formik={formik}
            label={t("deliveryAddress")}
            name={"deliveryAddress"}
            placeholder={t("deliveryAddress")}
          />
          <TextInput
            icon={<LocationIcon className="size-6" fill={"#888888"} />}
            formik={formik}
            label={t("receiptAddress")}
            name={"receiptAddress"}
            placeholder={t("receiptAddress")}
          />
        </section>

        <h2 className="my-4 text-xl capitalize">{t("shipmentType")}</h2>
        <section className="flex flex-col gap-2 inputs md:flex-row">
          <label
            htmlFor="shipment-type-normal"
            className="w-full p-4 font-bold text-center capitalize transition-all rounded-lg cursor-pointer dark:bg-gray-800"
            style={{
              color:
                formik.values.shipmentType === "normal"
                  ? getContrastingTextColor(primaryColor)
                  : "#6c6c72",
              backgroundColor:
                formik.values.shipmentType === "normal" ? primaryColor : "white",
            }}
          >
            <input
              type="radio"
              name="shipmentType"
              className="absolute top-0 left-0 hidden"
              id="shipment-type-normal"
              onChange={formik.handleChange}
              value={"normal"}
            />
            {t("normal")}
          </label>

          <label
            htmlFor="shipment-type-fast"
            className="w-full p-4 font-bold text-center capitalize transition-all rounded-lg cursor-pointer dark:bg-gray-800"
            style={{
              color:
                formik.values.shipmentType === "fast"
                  ? getContrastingTextColor(primaryColor)
                  : "#6c6c72",
              backgroundColor:
                formik.values.shipmentType === "fast" ? primaryColor : "white",
            }}
          >
            <input
              type="radio"
              name="shipmentType"
              className="absolute top-0 left-0 hidden"
              id="shipment-type-fast"
              onChange={formik.handleChange}
              value={"fast"}
            />
            {t("fast")}
          </label>
        </section>

        <div className="my-4">
          <h3 className="block mb-1 font-bold text-[20px] capitalize">
            {t("shippingCost")}
          </h3>
          <section className="flex items-center gap-2">
            <p className="flex font-bold text-mainGray dark:text-gray-400 min-w-[300px] items-center justify-center gap-1 p-3 text-center bg-white dark:bg-gray-900 cursor-not-allowed rounded-xl">
              <span>$</span>
              <span>150</span>
            </p>
            <p className="font-bold text-gray-700 dark:text-gray-300">
              {t("calculatedBasedOnRegion")}
            </p>
          </section>
        </div>

        <BoardButton secondary bg>
          {t("confirm")}
        </BoardButton>
      </form>

      <MessagePopup
        text={
          <div className="text-center">
            <p className="my-2 font-medium">{t("billIssuesSuccess")}</p>
            <p className="text-sm text-mainGray dark:text-gray-400">
              {t("billNumber")}: WB-2023-1242
            </p>
          </div>
        }
        icon={<QrCodeIcon className={"dark:invert"} />}
        state={requestSent}
        setState={setRequestSent}
      />
    </main>
  );
};

export default IssueBillLading;
